import { ButtonHTMLAttributes, forwardRef, ReactNode } from 'react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { AssignmentPaletteEntity } from './assignmentPaletteEntities'

type Props = {
  label: ReactNode
  assignmentCount?: number
  disabled?: boolean
  category: AssignmentPaletteEntity['category']
  highlighted?: boolean
  showCount?: boolean
  className?: string
} & Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'>

const AssignmentPaletteEntityButton = forwardRef<HTMLButtonElement, Props>(
  (
    {
      label,
      assignmentCount = 0,
      disabled = false,
      category,
      highlighted = false,
      showCount = true,
      className,
      ...props
    },
    ref,
  ) => {
    return (
      <Button
        ref={ref}
        type='button'
        variant='outline'
        size='sm'
        className={cn(
          'h-auto items-stretch justify-between gap-0 overflow-hidden p-0',
          disabled && 'cursor-not-allowed',
          highlighted && 'border-primary',
          className,
        )}
        disabled={disabled}
        {...props}
      >
        <span className='inline-flex min-w-0 flex-1 items-center px-2 py-1 text-left'>
          {label}
        </span>
        {showCount ? (
          <span
            className={cn(
              'inline-flex shrink-0 items-center self-stretch border-l bg-muted px-2 text-sm text-muted-foreground tabular-nums',
              assignmentCount > 1 &&
                category !== 'by_role' &&
                category !== 'by_class' &&
                'text-info-foreground bg-info',
            )}
          >
            {assignmentCount}
          </span>
        ) : null}
      </Button>
    )
  },
)

AssignmentPaletteEntityButton.displayName = 'AssignmentPaletteEntityButton'

export default AssignmentPaletteEntityButton
